import { render } from "./venderRateSetting.vue?vue&type=template&id=82e0bd22&scoped=true"
import script from "./venderRateSetting.vue?vue&type=script&lang=js"
export * from "./venderRateSetting.vue?vue&type=script&lang=js"

import "./venderRateSetting.vue?vue&type=style&index=0&id=82e0bd22&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e0bd22"]])

export default __exports__